var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('btn',{staticClass:"smvp-like-button",class:_vm.classes,style:(_vm.cssOverrides),on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon',{attrs:{"name":"thumb-up"}}),_c('span',{staticClass:"smvp-like-count"},[_vm._v(_vm._s(_vm.likes))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }